import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { cn } from '@/lib/cn';
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverContent = React.forwardRef<React.ElementRef<typeof PopoverPrimitive.Content>, React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
  container?: PopoverPrimitive.PopoverPortalProps['container'];
}>(({
  className,
  align = 'start',
  sideOffset = 4,
  side = 'bottom',
  container,
  onWheel,
  onTouchMove,
  ...props
}, ref) => <PopoverPrimitive.Portal container={container}>
      <PopoverPrimitive.Content ref={ref} align={align} side={side} sideOffset={sideOffset} onClick={e => e.stopPropagation()}
  /**
   * @note
   * Dialogの中でPopoverを使用する際、スクロールイベントが親要素に伝播されることでPopoverのスクロールが機能しない問題がある。
   * onWheelとonTouchMoveでイベントの伝播を停止することで、デスクトップとモバイル両方でスクロール可能にしている
   * @see https://github.com/radix-ui/primitives/issues/1159
   */ onWheel={e => {
    e.stopPropagation();
    onWheel?.(e);
  }} onTouchMove={e => {
    e.stopPropagation();
    onTouchMove?.(e);
  }} className={cn('z-50 w-72 rounded-md border bg-popover text-popover-foreground shadow-md outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2', className)} {...props} />
    </PopoverPrimitive.Portal>);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
const PopoverClose = PopoverPrimitive.Close;
export { Popover, PopoverAnchor, PopoverClose, PopoverContent, PopoverTrigger };